import { I18nUtils } from '../../../../../i18n/I18nUtils';
import React from 'react';
import PropTypes from 'prop-types';

const INIT_STATE = {
    date: '',
    month: -1,
    year: -1,
};

export class TaskDateInput extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...INIT_STATE,
            date: props.date ? props.date : INIT_STATE.date,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            handleSetMonth,
            handleSetYear,
        } = this.props;

        if ( prevState.date !== this.state.date && handleSetYear && handleSetMonth) {
            if ( ( this.state.date.length === 7 && this.state.date.indexOf('/') === 2 ) || ( this.state.date.length === 6 && this.state.date.indexOf('/') === 1 ) ) {
                const dates = this.state.date.split('/');
                try {
                    const month = parseInt(dates[0], 10);
                    const year = parseInt(dates[1], 10);
                    handleSetMonth(month);
                    handleSetYear(year);
                } catch (e) {
                    handleSetMonth(INIT_STATE.month);
                    handleSetYear(INIT_STATE.year);
                }
            } else {
                handleSetMonth(INIT_STATE.month);
                handleSetYear(INIT_STATE.year);
            }
        }
    }

    handleChangeDate = (event) => {
        const { handleSetDate } = this.props;

        const date = event.target.value;
        this.setState({ date });
        if (handleSetDate) {
            handleSetDate(date);
        }
    };

    render() {
        const { date } = this.state;

        return (
            <input
                type="text"
                className="form-control date"
                placeholder={I18nUtils.tr('TR_MES_ANO')}
                value={date}
                onChange={this.handleChangeDate}/>
        );
    }
}

TaskDateInput.propTypes = {
    handleSetMonth: PropTypes.func,
    handleSetYear: PropTypes.func,
    handleSetDate: PropTypes.func,
    date: PropTypes.string,
};




// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/components/TaskDateInput.jsx